import React from 'react';
import ProgressiveImage from 'react-progressive-image';
import { getTheBestImageFormat } from '../../utils/common';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal(props) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>Auto service website</h1>
			<p className='project-popup__description '>
				That's a responsive landing website for auto service. It's created using BEM
				methodology.
			</p>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>
						Design, HTML, SCSS, responsive web, BEM, JavaScript, PWA, Yandex maps,
						SEO
					</span>
				</p>
			</div>
			<div className='project-popup__images '>
				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/auto21/1.webp',
						backupImage: './media/projects/auto21/1.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => (
						<img className='no-margin-img small-img' src={src} alt='auto-image1' />
					)}
				</ProgressiveImage>
				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/auto21/2.webp',
						backupImage: './media/projects/auto21/2.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => (
						<img className='no-margin-img small-img' src={src} alt='auto-image2' />
					)}
				</ProgressiveImage>

				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/auto21/3.webp',
						backupImage: './media/projects/auto21/3.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => (
						<img className='no-margin-img small-img' src={src} alt='auto-image3' />
					)}
				</ProgressiveImage>

				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/auto21/4.webp',
						backupImage: './media/projects/auto21/4.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img className='small-img' src={src} alt='auto-image4' />}
				</ProgressiveImage>

				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/auto21/5.webp',
						backupImage: './media/projects/auto21/5.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img className='no-margin-img' src={src} alt='auto-image5' />}
				</ProgressiveImage>

				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/auto21/6.webp',
						backupImage: './media/projects/auto21/6.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img className='no-margin-img' src={src} alt='auto-image6' />}
				</ProgressiveImage>

				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/auto21/7.webp',
						backupImage: './media/projects/auto21/7.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img className='no-margin-img' src={src} alt='auto-image7' />}
				</ProgressiveImage>

				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/auto21/8.webp',
						backupImage: './media/projects/auto21/8.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => <img className='no-margin-img' src={src} alt='auto-image8' />}
				</ProgressiveImage>
			</div>
			<div className='project-popup__buttons'>
				<a
					href='http://autotaganrog.ru'
					className='project-link '
					target='_blank'
					rel='noopener noreferrer'
				>
					Visit project
				</a>
				<CloseModalButton onClose={props.closeModal} />
			</div>
		</div>
	);
}
